import FormStyles from './index.module.scss';

class ImageField {
	static selectors = {
		field: FormStyles['field-image'],
		browse: FormStyles['field-image-browse'],
		preview: FormStyles['field-image-preview'],
		remove: FormStyles['field-image-remove']
	}

	static init() {
		const fields = document.getElementsByClassName(this.selectors.field) as HTMLCollectionOf<HTMLElement>;
		for (const field of fields) {
			new ImageField(field);
		}
	}

	fieldElement: HTMLElement;
	browseElement: HTMLButtonElement;
	fileElement: HTMLInputElement;
	previewElement: HTMLElement;
	imageElement: HTMLImageElement;

	constructor(field: HTMLElement) {
		this.setElements(field);
		this.bindHandlers();
		this.browseElement.addEventListener('click', this.browse);
		this.fileElement.addEventListener('change', this.change);
	}

	bindHandlers() {
		this.browse = this.browse.bind(this);
		this.change = this.change.bind(this);
	}

	setElements(field: HTMLElement) {
		this.fieldElement = field;

		this.browseElement = field.getElementsByClassName(ImageField.selectors.browse)[0] as any;
		this.fileElement = field.querySelector('input[type=file]');

		this.previewElement = field.getElementsByClassName(ImageField.selectors.preview)[0] as any;
		this.imageElement = this.previewElement.getElementsByTagName('img')[0];
	}

	browse(e: MouseEvent) {
		e.preventDefault();
		this.fileElement.click();
	}

	change(e: Event) {
		const target = this.fileElement;
		const file = target.files && target.files[0];
		file ? this.showPreview(file) : this.hidePreview();
	}

	showPreview(file: File) {
		this.imageElement.src = URL.createObjectURL(file);
		this.previewElement.hidden = false;
		this.browseElement.hidden = true;
	}

	hidePreview() {
		this.browseElement.hidden = false
		this.previewElement.hidden = true;
		this.imageElement.removeAttribute('src');
	}
}

class TagField {
	static selectors = {
		tagNew: FormStyles['tag-new']
	}

	static init() {
		const fields = document.getElementsByClassName(this.selectors.tagNew) as HTMLCollectionOf<HTMLElement>;
		for (const field of fields) {
			new TagField(field);
		}
	}

	inputElement: HTMLInputElement;
	labelElement: HTMLLabelElement;

	constructor(field: HTMLElement) {
		this.setElements(field);
		this.bindHandlers();

		this.labelElement.addEventListener('click', this.startEditing);
		this.inputElement.addEventListener('blur', this.stopEditing);
		this.inputElement.addEventListener('keydown', this.commitValue);
	}

	bindHandlers() {
		this.startEditing = this.startEditing.bind(this);
		this.stopEditing = this.stopEditing.bind(this);
		this.commitValue = this.commitValue.bind(this);
	}

	setElements(field: HTMLElement) {
		this.inputElement = field.getElementsByTagName('input')[0];
		this.labelElement = field.getElementsByTagName('label')[0];
	}

	startEditing() {
		this.inputElement.hidden = false;
		this.labelElement.hidden = true;
	}

	stopEditing() {
		if (this.inputElement.value.length > 0) {
			return;
		}

		this.inputElement.hidden = true;
		this.labelElement.hidden = false;
	}

	commitValue(e: KeyboardEvent) {
		if (e.key !== 'Enter') return;
		e.preventDefault();

		const target = e.target as HTMLInputElement;
		target.blur();
	}
}

document.addEventListener('ready', ImageField.init.bind(ImageField));
document.addEventListener('ready', TagField.init.bind(TagField));
